import type { ComputedRef } from "vue";
import { computed } from "vue";

export default function (
  someObject: Record<string, unknown> | undefined
): string {
  return (
    "data:text/json;charset=utf-8," +
    encodeURIComponent(JSON.stringify(someObject))
  );
}
